import React, {Component} from "react";
import {connect} from 'react-redux';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import downGreenChevron from "../../images/down-green-chevron.png";
import {changeValue, fetchGreaterRegions, setVal} from "../../actions";

class GreaterRegionsMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            currentIndex: 0
        }
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    changeRegionValue(idx, greaterRegion) {
        this.setState({currentIndex: idx}, () => {
           this.updateWheel(greaterRegion);
        });
    }

    updateWheel(greaterRegion) {
        const { updateMarketPosition, setVal, fetchGreaterRegion,
            updateSVGDimensions, position, displayCities,
            sectorText, sectorColor } = this.props;
        let selectedWheelPosition = this.props.selectedWheelPosition;

        updateMarketPosition('', 0);
        // we have to show the same wheel position and the corresponding definition
        setVal(selectedWheelPosition,selectedWheelPosition)

        fetchGreaterRegion(greaterRegion);

        if(updateSVGDimensions) {
            updateSVGDimensions();
        }

        if (position){
            if(displayCities) {
                displayCities(sectorText, position, sectorColor);
            }
        }
    }


    render() {
       const greaterRegions = ['Global', 'Americas', 'Europe', 'Asia Pacific'];

        const { selectedRegion } = this.props;

        return(
            <div className='greater-region-wrapper'  onClick={() => this.toggle()}>
                <Dropdown className='greater-region-toggle'  isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                    <DropdownToggle id={'greater-region-toggle-nav'} className='greater-region-toggle' >
                        {selectedRegion}
                    </DropdownToggle>
                    <DropdownMenu className='greater-region-menu'>
                        {greaterRegions.map((greaterRegion,idx) =>
                            <DropdownItem className='greater-region-menu-item' key={idx} onClick={() => this.changeRegionValue(idx,greaterRegion)}>{greaterRegion}</DropdownItem>
                        )}
                    </DropdownMenu>
                </Dropdown>
                <span className={`arrow-nav float-right arrowposition-greater-region`}><img src={downGreenChevron} alt="downArrow" height="10" width="15"/></span>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedRegion: state.greaterRegions,
        selectedDefinition: state.selectedWheelPosition.selectedDefinition,
        selectedWheelPosition : state.selectedWheelPosition.selectedWheelPosition
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchGreaterRegion: (greaterRegion) => {
            dispatch(fetchGreaterRegions(greaterRegion));
        },
        updateMarketPosition: (marketid, positionid) => {
            dispatch(changeValue(marketid, positionid))
        },
        setVal: (selectedDefinition, selectedWheelPosition) => {
            dispatch(setVal(selectedDefinition, selectedWheelPosition))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GreaterRegionsMobile);